// Print layout of the XLSX quote, modelled on "BAO GIA TONG HOP (V).xlsx".
// Every preview page (cover, each table of 5 products, footer) is a block of
// rows that fits one A4 landscape page and ends with a manual page break.

export const PRODUCTS_PER_PAGE = 5;

export const FONT = "Times New Roman";
export const COLORS = {
  border: "FFA7A7A7",
  highlight: "FFFCE4E5", // preview: #eb1e27 at 15% on white
  header: "FFF5F5F5",
  red: "FFC00000",
  link: "FF0563C1",
};

export const COL_WIDTHS = [26.66, 23.11, 23.11, 23.11, 23.11, 23.11];
export const LAST_COL = "F";

// Exchange rate used by the VND formulas. It lives on a hidden sheet: a
// cell next to the table would be printed by LibreOffice/Google Sheets, which
// do not all honour the print area.
export const RATE_SHEET = "Rate";
export const RATE_CELL = "B1";
export const RATE_REF = `${RATE_SHEET}!$B$1`;

// No "fit to page": Excel ignores manual page breaks when Fit To is on, so a
// fixed scale is used and every block is kept under PAGE_HEIGHT_PT.
export const PAGE_SETUP = {
  paperSize: 9, // A4
  orientation: "landscape",
  scale: 95,
  fitToPage: false,
  horizontalCentered: true,
  margins: {
    left: 0.25,
    right: 0.25,
    top: 0.2,
    bottom: 0.2,
    header: 0,
    footer: 0,
  },
};

const A4_LANDSCAPE_IN = { width: 11.69, height: 8.27 };
const SAFETY_PT = 6;

// Printable height in sheet points at the chosen scale
export const PAGE_HEIGHT_PT =
  ((A4_LANDSCAPE_IN.height -
    PAGE_SETUP.margins.top -
    PAGE_SETUP.margins.bottom) *
    72 *
    100) /
    PAGE_SETUP.scale -
  SAFETY_PT;

export const PAGE_WIDTH_IN =
  ((A4_LANDSCAPE_IN.width -
    PAGE_SETUP.margins.left -
    PAGE_SETUP.margins.right) *
    100) /
  PAGE_SETUP.scale;

export const ROW_PT = {
  header: 15,
  image: 87.6,
  spacer: 6,
  contact: 42,
  max: 400, // Excel caps a row at 409pt
};
export const MAX_STRETCH = 1.6;

export const PX_PER_PT = 4 / 3;
export const EMU_PER_PX = 9525;

// Excel's char-width -> pixel conversion for the default font (Calibri 11)
export const colPx = (w) =>
  Math.trunc(((256 * w + Math.trunc(128 / 7)) / 256) * 7);
export const COL_PX = COL_WIDTHS.map(colPx);
export const SHEET_WIDTH_PX = COL_PX.reduce((a, b) => a + b, 0);
